export default __webpack_public_path__ + "static/media/SAFEVEHICLES.26941a6b.png";